 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import styled from '@emotion/styled'
import React, {} from 'react'
import useBreakpoint from '../hooks/useBreakpoint'
import {DECELERATE} from '../styles/animation'
import {desktopSidebarShadow, Elevation} from '../styles/elevation'
import {Breakpoint} from '../types/constEnums'
import StaticSidebar from './StaticSidebar'
import SwipeableDashSidebar from './SwipeableDashSidebar'










const Sidebar = styled('div')(({isOpen}) => ({
  boxShadow: isOpen ? desktopSidebarShadow : Elevation.Z0,
  transition: `box-shadow 200ms ${DECELERATE}`
}))

const ResponsiveDashSidebar = (props) => {
  const {children, isOpen, onToggle, isRightDrawer = false, sidebarWidth, isDesktop} = props
  const isDesktopDefault = useBreakpoint(Breakpoint.SIDEBAR_LEFT)
  const showDesktopView = _nullishCoalesce(isDesktop, () => ( isDesktopDefault))
  if (showDesktopView) {
    return (
      React.createElement(StaticSidebar, { isOpen: isOpen, isRightDrawer: isRightDrawer,}
        , React.createElement(Sidebar, { isOpen: isOpen,}, children)
      )
    )
  }
  return (
    React.createElement(SwipeableDashSidebar, {
      isOpen: isOpen,
      isRightDrawer: isRightDrawer,
      onToggle: onToggle,
      sidebarWidth: sidebarWidth,}

      , children
    )
  )
}

export default ResponsiveDashSidebar
